import { apiBasePath } from '@/utils/apiBasePath';
import {
  Configuration,
  FAQsApi,
  type CreateFaqGroupRequest,
  type CreateFaqRequest,
  type UpdateFaqGroupRequest,
  type UpdateFaqRequest,
} from '@teemill/faqs';
import { toValue, type MaybeRefOrGetter } from 'vue';
import { useAuthToken } from './auth';

const faqsClient = new FAQsApi(
  new Configuration({
    basePath: apiBasePath(),
    accessToken: async () => useAuthToken(),
    baseOptions: {
      headers: {
        'User-Agent': null,
      },
    },
  }),
);

export const useFAQs = (project: MaybeRefOrGetter<string>) => {
  return {
    faqsClient,
    faqs: {
      list: (form: { pageToken?: number; pageSize?: number; search?: string }) =>
        faqsClient
          .listFaqs({
            project: toValue(project),
            pageToken: form.pageToken,
            pageSize: form.pageSize,
            search: form.search,
          })
          .then(({ data }) => data),
      get: (faqId: string) =>
        faqsClient
          .getFaq({
            project: toValue(project),
            faqId,
          })
          .then(({ data }) => data),
      create: (faq: CreateFaqRequest) =>
        faqsClient
          .createFaq({
            project: toValue(project),
            createFaqRequest: faq,
          })
          .then(({ data }) => data),
      update: (faqId: string, faq: UpdateFaqRequest) =>
        faqsClient
          .updateFaq({
            project: toValue(project),
            faqId,
            updateFaqRequest: faq,
          })
          .then(({ data }) => data),
      delete: (faqId: string) =>
        faqsClient
          .deleteFaq({
            project: toValue(project),
            faqId,
          })
          .then(({ data }) => data),
    },
    groups: {
      list: (form: { pageToken?: number; pageSize?: number; search?: string }) =>
        faqsClient
          .listFaqGroups({
            project: toValue(project),
            pageToken: form.pageToken,
            pageSize: form.pageSize,
            search: form.search,
          })
          .then(({ data }) => data),
      get: (faqGroupId: string) =>
        faqsClient
          .getFaqGroup({
            project: toValue(project),
            faqGroupId,
          })
          .then(({ data }) => data),
      create: (faqGroup: CreateFaqGroupRequest) =>
        faqsClient
          .createFaqGroup({
            project: toValue(project),
            createFaqGroupRequest: faqGroup,
          })
          .then(({ data }) => data),
      update: (faqGroupId: string, faqGroup: UpdateFaqGroupRequest) =>
        faqsClient
          .updateFaqGroup({
            project: toValue(project),
            faqGroupId,
            updateFaqGroupRequest: faqGroup,
          })
          .then(({ data }) => data),
      delete: (faqGroupId: string) =>
        faqsClient
          .deleteFaqGroup({
            project: toValue(project),
            faqGroupId,
          })
          .then(({ data }) => data),
    },
  };
};
